import { z } from 'zod';

/**
 * Brands — per-tenant item brand/manufacturer master data (ported from the old
 * POS). Each brand has a title, an optional logo (stored via the generic
 * attachments API with entityType='brand'), a sort order, and an active flag.
 * Items reference one brand via brandId.
 *
 * Distinct from the design-system BrandConfig (logo/colors) in `@erp/shared/brand`.
 */
export const BrandSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  title: z.string().min(1).max(200),
  sort: z.number().int(),
  isActive: z.boolean(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type Brand = z.infer<typeof BrandSchema>;

export const BrandCreateSchema = z.object({
  title: z.string().min(1).max(200),
  sort: z.number().int().optional(),
});
export type BrandCreate = z.infer<typeof BrandCreateSchema>;

export const BrandUpdateSchema = z.object({
  title: z.string().min(1).max(200).optional(),
  sort: z.number().int().optional(),
  isActive: z.boolean().optional(),
});
export type BrandUpdate = z.infer<typeof BrandUpdateSchema>;
